import React from 'react'
import IcomoonReact from 'icomoon-react'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import HorizontalLine from 'src/components/Elements/HorizontalLine'
import layoutStyles from '../layouts.module.scss'

const RightSidePanelHeader = ({ icon, iconColor, title }) => (
  <div className={layoutStyles.sidePanelHeaderContainer}>
    <div className={layoutStyles.sidePanelText}>
      {icon && (
        <IcomoonReact
          iconSet={rebrandIconSet}
          color={iconColor}
          size={23}
          icon={icon}
          className={generalStyles.mr20}
        />
      )}
      <span className={fontStyles.pdefaultboldlsgraphik18pt}>{title}</span>
    </div>
    <div className={generalStyles.mt20} />
    <HorizontalLine color={'c03silvere8e8e8'} fullWidth={true} />
  </div>
)

export default RightSidePanelHeader
